/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type KillswitchesGetSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesGetRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type KillswitchesGetSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesGetSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesGetSecurity$Outbound,
  KillswitchesGetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesGetSecurityToJSON(
  killswitchesGetSecurity: KillswitchesGetSecurity,
): string {
  return JSON.stringify(
    KillswitchesGetSecurity$outboundSchema.parse(killswitchesGetSecurity),
  );
}

/** @internal */
export type KillswitchesGetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const KillswitchesGetRequest$outboundSchema: z.ZodMiniType<
  KillswitchesGetRequest$Outbound,
  KillswitchesGetRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function killswitchesGetRequestToJSON(
  killswitchesGetRequest: KillswitchesGetRequest,
): string {
  return JSON.stringify(
    KillswitchesGetRequest$outboundSchema.parse(killswitchesGetRequest),
  );
}
